import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MultiSelectRepresentanteCLIComponent, MultiSelectRepresentanteIFComponent } from 'app/componentes-globales/componentes-globales.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessagesStatus, MessagesTitles } from './../../../models/messages';
import moment from 'moment';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { EmpresasService } from 'app/services/empresas/empresas.service';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MatChipInputEvent,
  MatAutocompleteSelectedEvent,
  MatAutocomplete
} from "@angular/material";
import Swal from 'sweetalert2';
import { GuiasService } from 'app/services/guias/guias.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FirmaElectronicaService } from '../../../services/firma-electronica/firma-electronica.service';
import { Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ComunicacionService } from 'app/services/comunicacionService/comunicacion.service';

declare var $: any;

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-nuevo-pagare',
  templateUrl: './nuevo-pagare.component.html',
  styleUrls: ['./nuevo-pagare.component.scss'],
  providers: [MessagesTitles, MessagesStatus, {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class NuevoPagareComponent implements OnInit {

  abrirAgregarAdquirente: boolean;
  loading: boolean = false;
  isLoading = true;
  user: any;
  formTipoP: FormGroup;
  formDataEnviar: FormGroup;
  dataEnviar: any = {};
  Fecha = moment();
  idContratoM: any;
  tipoP: any;
  now = moment();
  save: boolean = false;
  rProvCombo: any = [];
  idEmpresa: any;
  moned = '2';

  error: boolean = false;

  rAvalCombo: any = [];

  selectedItems = [];
  selectedItemsCLI = [];

  dropdownSettings2 = {};
  dropdownSettings4 = {};
  requiredField2: boolean = true;
  requiredField3: boolean = true;
  inputDefault2: any = [];
  searchField2: string = "";
  dropdownList2 = [];
  selectedItems2 = [];

  tipoProceso: any = 141;
  dataEnviarKeynua: any = {};
  dataContract: any = [];
  abrirAgregarAvalJ: boolean = false;
  AvalJuridicos: any = [];

  AvalID = new FormControl();
  AvalArr;
  filteredAval: Observable<any[]>;
  id;
  AvalTemporal: any = {}
  search: boolean = true;
  allprueba: string[] = [];
  repaval: any = [];
  repavalCrt = new FormControl('');
  idAval = "";
  dataRepAvalJ: any = [];
  filteredRepAvalJ: Observable<string[]> = new Observable(observer => observer.next([]));
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  AvalFilter: any = [];
  AvalFilter2: any = [];

  @Output() cerrarNuevoP: EventEmitter<boolean> = new EventEmitter();
  @Output() refresh: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('multiselectIF', { static: false }) multiselectIF: MultiSelectRepresentanteIFComponent;
  @ViewChild('multiselectCLI', { static: false }) multiselectCLI: MultiSelectRepresentanteCLIComponent;
  @ViewChild('AvalInput', { static: true }) AvalInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto2', { static: true }) matAutocomplete: MatAutocomplete;

  constructor(private empresasService: EmpresasService,
    private datePipe: DatePipe,
    private guiasService: GuiasService,
    private firmaElectronicaService: FirmaElectronicaService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private comunicacionService: ComunicacionService) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.idEmpresa = this.empresasService.pagareDatos.idEmpresa
    this.ObtenerClienteCombo()
    this.formDataEnviar = new FormGroup({
      "Fecha_Inicio": new FormControl(this.now, [Validators.required]),
      "Observaciones": new FormControl(''),
      "Correo": new FormControl('', Validators.required),
      "IF_Representante_Legal_1": new FormControl('', Validators.required),
      "IF_Representante_Aval": new FormControl(''),
      "idContratoMarco": new FormControl(''),
      "idOperacion": new FormControl('')
    });

    this.formTipoP = new FormGroup({
      tipoPagare: new FormControl(true),
      Moneda: new FormControl(),
      Importe: new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
      Fecha_Fin: new FormControl(""),
      Alta_Canal: new FormControl('W', []),
      Alta_Fecha: new FormControl(this.now),
      Tieneaval: new FormControl(true),
      TipoAval: new FormControl(true),
      AvalJuridico: new FormControl()
    });
  }

  ngOnInit() {
    this.cargarAvalesJuridicos();
    this.obtenerContratosMarco(this.idEmpresa.toString(), this.empresasService.pagareDatos.Tipo_Servicio);
    this.ListarRepresentantesEmpresa(this.idEmpresa);

    this.dropdownSettings2 = {
      singleSelection: false,
      text: "Select guarantor signatory",
      selectAllText: 'Select all',
      unSelectAllText: 'Deselect all',
      enableSearchFilter: false,
      labelKey: 'NombreCorreo',
      primaryKey: 'idContacto',
      classes: "myclass custom-class",
      badgeShowLimit: 3
    };
    this.dropdownSettings4 = {
      singleSelection: false,
      text: "Seleccione Firmante",
      selectAllText: 'Select all',
      unSelectAllText: 'Deselect all',
      enableSearchFilter: false,
      labelKey: 'Nombre_Comercial',
      primaryKey: 'idEmpresa',
      classes: "myclass custom-class",
      badgeShowLimit: 3
    };

  }

  representanteIF(event) {
    this.selectedItems = event;
  }

  representanteCLI(event) {
    this.selectedItemsCLI = event;
  }

  private obtenerSeleccionFirmantesIF(): any[] {
    if (this.multiselectIF && this.multiselectIF.selectedItems && this.multiselectIF.selectedItems.length) {
      return this.multiselectIF.selectedItems;
    }
    return this.selectedItems || [];
  }

  private obtenerSeleccionFirmantesCLI(): any[] {
    if (this.multiselectCLI && this.multiselectCLI.selectedItems && this.multiselectCLI.selectedItems.length) {
      return this.multiselectCLI.selectedItems;
    }
    return this.selectedItemsCLI || [];
  }

  addDataSelects() {
    const firmantesIF = this.obtenerSeleccionFirmantesIF();
    const firmantesCLI = this.obtenerSeleccionFirmantesCLI();
    this.selectedItems = firmantesIF.slice();
    this.selectedItemsCLI = firmantesCLI.slice();

    this.dataEnviar.Firmantes = [];
    firmantesCLI.forEach(item => {
      this.dataEnviar.Firmantes.push(
        {
          'Nombre_Firmante': item.Nombre_de_Contacto,
          'Correo': item.Correo,
          'Telefono': item.NroMovil_Laboral,
          'Tipo_Doc_Identificacion': item.Tipo_Documento_Identidad,
          'Tipo_Doc_Identificacion_Dsc': item.Tipo_Documento_Identidad_Dsc,
          'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
          'Tipo_Firmante': item.Tipo_de_Contacto,
          'Cargo': item.Des_Tipo_de_Contacto,
          'Raz_Social': item.Razon_Social,
          'RUC': item.Num_Doc_Identificacion,
          'Direccion': item.Direccion_Fiscal,
          'Distrito': item.Distrito,
        }
      )
    });

    if (this.selectedItems2.length == 0 && this.formTipoP.controls['TipoAval'].value == true && this.formTipoP.controls['Tieneaval'].value == true) {
      this.dataEnviar.TieneAval = 1
      this.dataEnviar.Tipo_Aval = 1;
      this.AvalFilter2 = [];
      for (let item of this.dataRepAvalJ) {
        this.repaval.forEach((item1, index) => {
          if (item.Nombre_de_Contacto.trim() == this.repaval[index].trim()) {
            this.AvalFilter2.push(item);
          }
        });

      }

      this.AvalFilter2.forEach(item => {
        this.dataEnviar.Firmantes.push(
          {
            'Nombre_Firmante': item.Nombre_de_Contacto,
            'Correo': item.Correo,
            'Telefono': item.NroMovil_Laboral,
            'Tipo_Doc_Identificacion': item.Tipo_Documento_Identidad,
            'Tipo_Doc_Identificacion_Dsc': item.Tipo_Documento_Identidad_Dsc,
            'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
            'Tipo_Firmante': 2,
            'Cargo': "AVAL JURIDICO",
            'Raz_Social': item.Razon_Social,
            'RUC': item.Num_Doc_Identificacion,
            'Direccion': item.Direccion_Persona,
            'Distrito': item.Distrito,
          }
        )
      });
    } else if (this.selectedItems2.length > 0 && this.formTipoP.controls['TipoAval'].value == false && this.formTipoP.controls['Tieneaval'].value == true) {
      this.dataEnviar.TieneAval = 1
      this.dataEnviar.Tipo_Aval = 0;
      this.selectedItems2.forEach(item => {
        this.dataEnviar.Firmantes.push(
          {
            'Nombre_Firmante': item.Nombre_de_Contacto,
            'Correo': item.Correo,
            'Telefono': item.NroMovil_Laboral,
            'Tipo_Doc_Identificacion': item.Tipo_Documento_Identidad,
            'Tipo_Doc_Identificacion_Dsc': item.Tipo_Documento_Identidad_Dsc,
            'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
            'Tipo_Firmante': item.Rol_del_Contacto,
            'Cargo': item.Rol_Del_Contacto_Dsc,
            'Raz_Social': item.Razon_Social,
            'RUC': item.Num_Doc_Identificacion,
            'Direccion': item.Direccion_Persona,
            'Distrito': item.Distrito_Persona,
          }
        )
      });
    } else {
      this.dataEnviar.TieneAval = 0;
    }

    firmantesIF.forEach(item => {
      this.dataEnviar.Firmantes.push({
        Nombre_Firmante: item.Nombre_Firmante || '',
        Correo: (item.Correo || '').trim() || ' ',
        Telefono: item.Telefono || '',
        Tipo_Doc_Identificacion: item.Tipo_Doc_Identificacion || '',
        Num_Doc_Identificacion: item.Num_Doc_Identificacion || '',
        Distrito: item.Distrito || '',
        Tipo_Firmante: item.Tipo_Firmante || 1,
        Cargo: item.Cargo || '',
        Raz_Social: item.Raz_Social || '',
        RUC: item.RUC || '',
        Direccion: item.Direccion || '',
      });
    });

  }

  private obtenerMensajeErrorPagare(err: HttpErrorResponse): string {
    if (err.error && typeof err.error.error === 'string' && err.error.error.trim()) {
      return err.error.error;
    }
    if (err.error && typeof err.error.message === 'string' && err.error.message.trim()) {
      return err.error.message;
    }
    this.msgStatus.getMessage(err.status);
    return this.msgStatus.message || 'Unexpected error.';
  }

  obtenerContratosMarco(idEmpresa, tipoServicio) {
    let operacion: any = [];
    this.empresasService.obtenerContratosMarco(idEmpresa, tipoServicio)
      .subscribe(res => {
        operacion = res;
        operacion = operacion.filter(
          state => state.Estado.toLowerCase().indexOf("a") === 0
        );
        if (operacion.length != 0) {
          this.formDataEnviar.controls['idContratoMarco'].setValue(operacion[0].IDCMarco);
        }
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: "An error occurred!",
          text: "Contrato marco no encontrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      });
  }

  CerrarPopUp() {
    this.cerrarNuevoP.emit();
    this.guiasService.setDataRepresentanteCLI([]);
  }

  nuevoPagare() {
    const firmantesIF = this.obtenerSeleccionFirmantesIF();
    const firmantesCLI = this.obtenerSeleccionFirmantesCLI();

    if (firmantesIF.length === 0 || firmantesCLI.length === 0) {
      const detalle = [];
      if (firmantesIF.length === 0) {
        detalle.push('firmante del factor (IF)');
      }
      if (firmantesCLI.length === 0) {
        detalle.push('firmante del cliente/proveedor');
      }
      Swal.fire({
        title: "It´s necessary to fill in the signatories!",
        text: 'Seleccione al menos un ' + detalle.join(' y un ') + '.',
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    this.selectedItems = firmantesIF.slice();
    this.selectedItemsCLI = firmantesCLI.slice();

    if (!this.verificar()) {
      return;
    }

    this.loading = true;
    this.empresasService.CrearPagare(this.dataEnviar).subscribe(
      res => {
        this.loading = false;
        this.save = true;
        Swal.fire({
          title: '¡Registro exitoso!',
          text: '¿Desea enviar a firma electrónica?',
          type: "success",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí',
          cancelButtonText: 'No',
          heightAuto: false
        }).then((result) => {
          if (result.value) {
            this.dataContract = res;
            if (this.dataContract.idPagare === undefined) {
              this.dataEnviarKeynua.idPagare = this.dataContract.idProceso;
            } else {
              this.dataEnviarKeynua.idPagare = this.dataContract.idPagare;
            }
            this.enviarPagareElectronico(this.dataEnviarKeynua);
            this.cerrarNuevoP.emit();
            this.refresh.emit();
          } else if (
            result.dismiss === Swal.DismissReason.cancel
          ) {
            this.cerrarNuevoP.emit();
            this.refresh.emit();
          }
        });
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Promissory note not created. " + this.obtenerMensajeErrorPagare(err),
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      })
  }
  verificar(): boolean {
    if (this.formTipoP.controls['tipoPagare'].value == false) {
      this.tipoP = "139";
    } else {
      this.tipoP = "138";
    }
    this.addDataSelects();
    this.dataEnviar.Observaciones = this.formDataEnviar.controls['Observaciones'].value
    if (this.formDataEnviar.controls['idContratoMarco'].value != '') {
      this.dataEnviar.IDCMarco = this.formDataEnviar.controls['idContratoMarco'].value;
    }
    if (this.formDataEnviar.controls['idOperacion'].value != '') {
      this.dataEnviar.idOperacion = this.formDataEnviar.controls['idOperacion'].value;
    }
    this.dataEnviar.Fecha = this.datePipe.transform(this.formDataEnviar.controls['Fecha_Inicio'].value, 'yyyy-MM-dd');
    this.dataEnviar.Tipo_Pagare = this.tipoP;
    this.dataEnviar.Alta_Usuario = this.user.Usuario;
    this.dataEnviar.Alta_Canal = this.formTipoP.controls['Alta_Canal'].value;
    this.dataEnviar.Alta_Fecha = this.datePipe.transform(this.formTipoP.controls['Alta_Fecha'].value, 'yyyy-MM-dd');
    this.dataEnviar.Tipo_Proceso = this.tipoProceso;
    this.dataEnviar.idEmpresa = this.idEmpresa;
    this.dataEnviar.idEmpresa_Factor = this.user.id_empresa;
    this.dataEnviar.Tipo_Servicio = this.empresasService.pagareDatos.Tipo_Servicio;
    if (this.dataEnviar.Tipo_Pagare == 138) {
      this.dataEnviar.Moneda = this.formTipoP.controls['Moneda'].value;
      this.dataEnviar.Fecha_Vencimiento = this.datePipe.transform(this.formTipoP.controls['Fecha_Fin'].value, 'yyyy-MM-dd');
      this.dataEnviar.Importe = this.formTipoP.controls['Importe'].value;
      if (!this.dataEnviar.Moneda || !this.dataEnviar.Fecha_Vencimiento || this.dataEnviar.Importe == "" || this.dataEnviar.Importe == "0.0") {
        Swal.fire({
          title: "¡Advertencia!",
          text: "It's necessary to fill in all the fields to generate a complete promissory note.",
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        return false;
      }
    }
    if (this.dataEnviar.Tipo_Pagare == 139 && this.formDataEnviar.controls['idContratoMarco'].value == '') {
      Swal.fire({
        title: "¡Advertencia!",
        text: "It's necessary to fill in all the fields to generate a complete promissory note.",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return false;
    }
    return true;
  }
  enviarPagareElectronico(dataEnviarKeynua) {

    this.firmaElectronicaService.enviarPagareElectronico(dataEnviarKeynua).subscribe(
      res => {
        this.showNotification('success', 'top', 'right', 'Document sent for e-Sign.');
      }, err => {
        if (err.error.message) {
          this.showNotification('warning', 'top', 'right', 'Could not be sent for e-Sign. \n Error: ' + err.error.message);
        } else {
          let error = "";
          error = err.error.error;
          this.showNotification('warning', 'top', 'right', 'Could not be sent for e-Sign. \n Error: ' + error);
        }

      }
    );
  }

  tipoMoneda(event) {
    this.formTipoP.controls['Moneda'].setValue(event);
  }

  ListarRepresentantesEmpresa(idEmpresa) {
    this.guiasService.setDataRepresentanteCLI([]);
    this.loading = true;
    this.empresasService.obtenerContactosEmpresa(idEmpresa).subscribe(
      res => {
        const contactos = Array.isArray(res) ? res : [];
        this.rProvCombo = contactos.slice();
        this.rAvalCombo = contactos.slice();

        this.guiasService.TipoContacto.pipe(take(1)).subscribe(tipoContacto => {
          const tipoContactoArr = Array.isArray(tipoContacto) ? tipoContacto : [];
          const guiaTipo = tipoContactoArr.find(state => state.Codigo.toLowerCase().indexOf('rl') === 0);

          let firmantesCliente = this.rProvCombo.filter(
            state => state.Des_Estado.toLowerCase().indexOf('activo') === 0
              && guiaTipo
              && state.Tipo_de_Contacto === guiaTipo.idGuia
          );

          if (firmantesCliente.length === 0) {
            firmantesCliente = this.rProvCombo.filter(
              state => state.Des_Estado.toLowerCase().indexOf('activo') === 0
            );
          }

          this.rProvCombo = firmantesCliente;
          this.guiasService.setDataRepresentanteCLI(this.rProvCombo);
        });

        this.guiasService.RolContacto.pipe(take(1)).subscribe(rolContacto => {
          const rolContactoArr = Array.isArray(rolContacto) ? rolContacto : [];
          const guiaRol = rolContactoArr.find(state => state.Codigo.toLowerCase().indexOf('ava') === 0);
          this.inputDefault2 = [];

          this.rAvalCombo.forEach(state => {
            if (state.Des_Estado.toLowerCase().indexOf('activo') === 0 && guiaRol) {
              const array: any = String(state.Rol_Del_Contacto_Id || '').split(',');
              array.forEach(element => {
                const num = +element;
                if (num === guiaRol.idGuia) {
                  state.Rol_del_Contacto = guiaRol.idGuia;
                  state.Rol_Del_Contacto_Dsc = guiaRol.Descripcion;
                  this.inputDefault2.push(state);
                }
              });
            }
          });

          this.rAvalCombo = this.inputDefault2;
          this.loading = false;
        });
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Listado de representantes legales no encontrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      });
  }

  onItemSelect2(item: any) {
    this.setStatus2();
  }

  setStatus2() {
    (this.selectedItems2.length > 0) ? this.requiredField2 = true : this.requiredField2 = false;
  }

  OnItemDeSelect2(item: any) {
    this.setStatus2();
  }

  onSelectAll2(items: any) {
    this.setStatus2();
  }

  onDeSelectAll2(items: any) {
    this.selectedItems2 = [];
    this.setStatus2();
  }

  filterRecords2(textToSearch: string) {
    let tempArray = [];
    this.inputDefault2.forEach((item, index) => {
      if (item.Nombre_Firmante.indexOf(textToSearch.toLowerCase()) > -1) {
        tempArray.push(item);
      }
    })

    if (tempArray.length > 0) {
      this.selectedItems2 = tempArray;
    }
  }

  EnterobtenerRucRazSocialCli(termino: string = '') {
    if (termino != null && termino != '' && Array.isArray(this.AvalArr)) {
      const termino1 = termino.toLowerCase();
      const match = this.AvalArr.find(p => p.Razon_Social.toLocaleLowerCase().indexOf(termino1) >= 0);
      if (match) {
        this.asignarAvalJuridico(match);
        return;
      }
    }
    this.LimpiarRepresentantes();
  }

  obtenerId(AvalId: string) {
    const state = (this.AvalArr || []).find(item => String(item.idEmpresa) === String(AvalId));
    if (state) {
      this.asignarAvalJuridico(state);
      return;
    }
    this.AvalTemporal.idCliente = AvalId;
    this.formTipoP.controls['AvalJuridico'].setValue(AvalId);
    this.LimpiarRepresentantes();
  }

  ObtenerClienteCombo() {
    const stored = sessionStorage.getItem('lstavlCbo');
    this.AvalArr = stored ? JSON.parse(stored) : [];
    if (!Array.isArray(this.AvalArr)) {
      this.AvalArr = [];
    }
    this.filteredAval = this.AvalID.valueChanges.pipe(
      startWith(this.AvalID.value || ''),
      map(state => state ? this._filterCli(state) : this.AvalArr.slice())
    );
  }

  cargarAvalesJuridicos() {
    if (this.AvalArr && this.AvalArr.length > 0) {
      return;
    }
    this.ObtenerAvalesCombo();
  }

  ObtenerAvalesCombo() {
    this.empresasService.obtenerAvalJuridico().subscribe(res => {
      const avales = Array.isArray(res) ? res : [];
      sessionStorage.setItem('lstavlCbo', JSON.stringify(avales));
      this.ObtenerClienteCombo();
    }, () => {
      this.AvalArr = [];
      this.ObtenerClienteCombo();
    });
  }

  private _filterCli(value: string): any[] {
    if (!Array.isArray(this.AvalArr)) {
      return [];
    }
    const filterValue = value.toString().toLowerCase();
    return this.AvalArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  seleccionarAvalJuridico(event: MatAutocompleteSelectedEvent) {
    const razon = event.option.value;
    const state = (this.AvalArr || []).find(item => item.Razon_Social === razon);
    if (state) {
      this.asignarAvalJuridico(state);
    }
  }

  asignarAvalJuridico(state: any) {
    this.AvalTemporal.idCliente = state.idEmpresa;
    this.AvalTemporal.Num_Doc_Identificacion = state.Num_Doc_Identificacion;
    this.AvalTemporal.Tipo_Doc_Identificacion = state.Tipo_Doc_Identificacion;
    this.AvalTemporal.Razon_Social = state.Razon_Social;
    this.AvalTemporal.Direccion_Fiscal = state.Direccion_Fiscal;
    this.formTipoP.controls['AvalJuridico'].setValue(state.Num_Doc_Identificacion);
    this.LimpiarRepresentantes();
    this.ListarRepresentantesProv(true);
  }

  LimpiarRepresentantes() {
    this.search = true;
    this.allprueba.splice(0, this.allprueba.length);
    this.repaval.splice(0, this.repaval.length);
    this.repavalCrt.setValue('');
  }

  CerrarPopUpAdquirente(click: boolean) {
    this.abrirAgregarAdquirente = false;
  }

  Refresh() {
    this.ngOnInit();
  }

  nuevoContacto() {
    this.empresasService.addContactoEmpresa = true;
    this.abrirAgregarAdquirente = true;
    if (this.AvalTemporal.idCliente) {
      this.empresasService.pagareDatos.idAval = this.AvalTemporal.idCliente
      this.empresasService.pagareDatos.Razon_SocialAval = this.AvalTemporal.Razon_Social
    }
    this.comunicacionService.enviarData(this.empresasService.pagareDatos);
  }

  showNotification(type, from, align, message) {

    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

  CerrarPopUpAvalJ(click: boolean) {
    this.abrirAgregarAvalJ = false;
  }

  nuevoAvalJH() {
    this.abrirAgregarAvalJ = true;
  }

  private _filter(value: string): string[] {
    const filterValue = (value || '').toLowerCase();
    return this.allprueba.filter(nombre => nombre.toLowerCase().includes(filterValue));
  }

  private initFilteredRepAvalJ() {
    this.filteredRepAvalJ = this.repavalCrt.valueChanges.pipe(
      startWith(''),
      map(value => value ? this._filter(value) : this.allprueba.slice())
    );
  }

  public ListarRepresentantesProv(forceReload: boolean = false) {
    this.idAval = this.AvalTemporal.idCliente;
    if (!this.idAval || this.idAval === '0') {
      Swal.fire({
        title: 'Legal Guarantee required',
        text: 'First select a Legal Guarantee company in the field above.',
        type: 'info',
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }
    if (!forceReload && !this.search) {
      this.initFilteredRepAvalJ();
      return;
    }

    this.empresasService.obtenerContactosEmpresa(this.idAval).subscribe(
      res => {
        this.search = false;
        const contactos = Array.isArray(res) ? res : [];
        this.rAvalCombo = contactos.filter(
          state => state.Des_Estado && state.Des_Estado.toLowerCase().indexOf('activo') === 0
        );
        this.dataRepAvalJ = this.rAvalCombo;
        this.allprueba = this.dataRepAvalJ
          .map(item => (item.Nombre_de_Contacto || '').trim())
          .filter(nombre => nombre.length > 0);
        this.initFilteredRepAvalJ();

        if (this.allprueba.length === 0) {
          Swal.fire({
            title: 'No representatives found',
            text: 'La garantía jurídica seleccionada no tiene contactos activos. Agregue uno con el botón +.',
            type: 'warning',
            allowOutsideClick: true,
            heightAuto: false
          });
        }
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Listado de representantes legales no encontrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      });
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim() && this.repaval.length < 3) {
      this.repaval.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
    this.repavalCrt.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.repaval.indexOf(fruit);
    if (index >= 0) {
      this.repaval.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.repaval.length < 3) {
      this.repaval.push(event.option.viewValue);
      this.repavalCrt.setValue(null);
    }
  }

  validarCampos() {
    if (this.formTipoP.controls['tipoPagare'].value == false) {
      this.formTipoP.controls['Importe'].setValue('');
      this.formTipoP.controls['Fecha_Fin'].setValue('');
      this.selectedItems2 = [];
      this.AvalID.setValue('');
      this.obtenerId('');
      this.LimpiarRepresentantes();
      this.repaval = [];
      this.formTipoP.controls['Tieneaval'].setValue(false);
      this.formTipoP.controls['TipoAval'].setValue(false)
    }
  }

  validarTieneAval() {
    if (this.formTipoP.controls['Tieneaval'].value == false) {
      this.selectedItems2 = [];
      this.AvalID.setValue('');
      this.obtenerId('');
      this.LimpiarRepresentantes();
      this.repaval = [];
    }
  }
  validarAval() {
    if (this.formTipoP.controls['TipoAval'].value == true) {
      this.selectedItems2 = [];
    } else {
      this.AvalID.setValue('');
      this.obtenerId('');
      this.LimpiarRepresentantes();
      this.repaval = [];
    }
  }

}

